import { render } from "./UserDropdown.vue?vue&type=template&id=33f79d1d"
import script from "./UserDropdown.vue?vue&type=script&lang=js"
export * from "./UserDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script